import React, { useMemo } from 'react';
import styled from 'styled-components';
import ScheduleCoordinationCell from './ScheduleCoordinationCell';

const TableWrapper = styled.div`
    width: 100%;
    overflow-x: auto;
    margin-top: 20px;
`;

const ScheduleTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
    background-color: white;
    
    th, td {
        border: 1px solid #ddd;
        text-align: center;
        vertical-align: middle;
    }
    
    thead th {
        background-color: #f5f5f5;
        font-weight: bold;
        position: sticky;
        top: 0;
        z-index: 20;
        padding: 5px 2px;
    }
    
    .employee-name-header {
        width: 80px;
        position: sticky;
        left: 0;
        z-index: 21;
        background-color: #f5f5f5;
    }
    
    .date-header {
        width: 40px;
        min-width: 40px;
    }
    
    .employee-name {
        background-color: #f5f5f5;
        font-weight: bold;
        padding: 8px 4px;
        position: sticky;
        left: 0;
        z-index: 20;
        word-break: keep-all;
        white-space: nowrap;
        text-align: center;
    }
`;

const DateCell = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    
    .weekday {
        font-size: 10px;
        color: #666;
        line-height: 1;
    }
    
    .day {
        font-size: 12px;
        font-weight: bold;
        line-height: 1;
        margin-top: 2px;
    }
`;

const ScheduleCoordinationTable = ({
    nowDate,
    users,
    draftSchedules,
    scheduleTypes,
    currentUser,
    isLocked,
    getColorForType,
    onDateDoubleClick,
    onRemoveSchedule,
    formatDate
}) => {
    // 計算該月的所有日期
    const dates = useMemo(() => {
        const year = nowDate.getFullYear();
        const month = nowDate.getMonth();
        const startDate = new Date(year, month, 1);
        const endDate = new Date(year, month + 1, 0);
        const days = [];
        
        for (let day = 1; day <= endDate.getDate(); day++) {
            days.push(new Date(year, month, day));
        }
        
        return days;
    }, [nowDate]);

    // 格式化星期幾
    const getWeekday = (date) => {
        const weekdays = ['日', '一', '二', '三', '四', '五', '六'];
        return weekdays[date.getDay()];
    };

    // 檢查是否為週末
    const isWeekend = (date) => {
        const day = date.getDay();
        return day === 0 || day === 6;
    };

    // 檢查是否為今天
    const isToday = (date) => {
        const today = new Date();
        return date.getDate() === today.getDate() &&
               date.getMonth() === today.getMonth() &&
               date.getFullYear() === today.getFullYear();
    };

    return (
        <TableWrapper>
            <ScheduleTable>
                <thead>
                    <tr>
                        <th className="employee-name-header">姓名</th>
                        {dates.map((date) => (
                            <th key={formatDate(date)} className="date-header">
                                <DateCell>
                                    <div className="weekday">{getWeekday(date)}</div>
                                    <div className="day">{date.getDate()}</div>
                                </DateCell>
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {users.length === 0 ? (
                        <tr>
                            <td colSpan={dates.length + 1} style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                                沒有員工資料
                            </td>
                        </tr>
                    ) : (
                        users.map((user) => (
                            <tr key={user.uuid}>
                                <td className="employee-name">{user.name}</td>
                                {dates.map((date) => {
                                    const dateStr = formatDate(date);
                                    const schedules = draftSchedules[dateStr] || [];
                                    const userSchedules = schedules.filter(s => s.user_uuid === user.uuid);
                                    // 檢查是否可編輯：未鎖定且是當前用戶
                                    const userToCheck = currentUser || window.currentUser;
                                    const canEdit = !isLocked && userToCheck && user.uuid === userToCheck.uuid;
                                    
                                    return (
                                        <ScheduleCoordinationCell
                                            key={`${user.uuid}-${dateStr}`}
                                            date={date}
                                            schedules={userSchedules}
                                            canEdit={canEdit}
                                            getColorForType={getColorForType}
                                            scheduleTypes={scheduleTypes}
                                            onDateDoubleClick={onDateDoubleClick}
                                            onRemoveSchedule={onRemoveSchedule}
                                            isWeekend={isWeekend(date)}
                                            isToday={isToday(date)}
                                            userUuid={user.uuid}
                                            formatDate={formatDate}
                                        />
                                    );
                                })}
                            </tr>
                        ))
                    )}
                </tbody>
            </ScheduleTable>
        </TableWrapper>
    );
};

export default ScheduleCoordinationTable;
